'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable import/no-mutable-exports, global-require */

var fetch = void 0;

if (__CLIENT__) {
  require('whatwg-fetch');

  fetch = window.fetch.bind(window);
} else {
  fetch = require('node-fetch').default;
}

exports.default = fetch;